// Web shim for react-native-linear-gradient
import React from 'react';
import { View, ViewStyle } from 'react-native';

interface LinearGradientProps {
  colors: string[];
  start?: { x: number; y: number };
  end?: { x: number; y: number };
  style?: ViewStyle | ViewStyle[];
  children?: React.ReactNode;
}

const LinearGradient: React.FC<LinearGradientProps> = ({
  colors,
  start = { x: 0, y: 0 },
  end = { x: 1, y: 0 },
  style,
  children,
}) => {
  const angle =
    Math.atan2(end.y - start.y, end.x - start.x) * (180 / Math.PI);
  const gradient = `linear-gradient(${angle}deg, ${colors.join(', ')})`;

  return (
    <View
      style={[style, { background: gradient } as unknown as ViewStyle]}
    >
      {children}
    </View>
  );
};

export default LinearGradient;
